interface AvatarProps {
  color?: string;
  borderColor?: string;
  borderWidth: number;
  width?: string | number;
  height?: string | number;
}

export default function Avatar({ color, borderColor, borderWidth, width = 74, height = 80 }: AvatarProps) {
  return (
    <div>
      <svg fill="none" height={height} viewBox="0 0 74 80" width={width} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="avatarClip">
            <circle cx="37" cy="37" r="36" />
          </clipPath>
        </defs>

        <g clipPath="url(#avatarClip)">
          <circle cx="37" cy="37" fill={color} r="36" />

          <path
            d="M60 68C56 73 46.5 78 37 78C27.5 78 18.5 73 13.5 68C18.5 62 27 57 37 57C47 57 55.5 62 60 68Z"
            fill="white"
          />

          <circle cx="37" cy="30" fill="white" r="21" />
        </g>

        <circle
          cx="36.5"
          cy="36.5"
          fill="none"
          r={36 - borderWidth / 2}
          stroke={borderColor}
          strokeWidth={borderWidth}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
}
